import ImageBuddy from 'imagebuddy';

class Banner {
	constructor(el) {
		this.el = el;
		this.imageColEl = this.el.querySelector('.banner-default__col-image');

		// animate immediately since the side image/shape is an SVG that is already rendered
		if (
			this.el.querySelector('.banner-default__side-image-container--type-shape') !== null &&
			this.imageColEl
		) {
			this.imageColEl.classList.remove('animate');
		}

		// wait until the side image is loaded to animate
		ImageBuddy.on('image-loaded', (imgEl) => {
			if (imgEl.classList.contains('banner-default__side-image') && this.imageColEl) {
				this.imageColEl.classList.remove('animate');
			}
		});
	}
}

export default Banner;
